import Vuex from "vuex";

import appStore from "./app";
import userStore from "./user";
import contactsStore from "./contacts";

export default Vuex.createStore({
  modules: {
    app: appStore,
    user: userStore,
    contacts: contactsStore
  }
});
